<template>
	<div class="ef-page-progress" :class="{ 'ef-page-progress-active': active }" role="presentation" aria-hidden="true">
		<div class="ef-page-progress-bar" :style="{ transform: `translate3d(${value - 100}%, 0, 0)` }" />
	</div>
</template>

<script setup lang="ts">
import usePageProgress from '@lib/progress/usePageProgress';

/**
 * The page-level loading bar. Rendered once by the layout and reads the shared state, so anything
 * can drive it through `usePageProgress()` without a prop chain - see that composable.
 */
const { active, value } = usePageProgress();
</script>

<style lang="scss">
.ef-page-progress {
	position: fixed;
	z-index: 2000; // above bootstrap's modal (1055) and toasts (1090)
	top: 0;
	left: 0;
	width: 100%;
	opacity: 0;
	// Fades out once finished, but appears instantly so short requests still register.
	transition: opacity 500ms ease;
	pointer-events: none;

	&.ef-page-progress-active {
		opacity: 1;
		transition: none;
	}

	.ef-page-progress-bar {
		width: 100%;
		height: 2px;
		transform: translate3d(-100%, 0, 0);
		background-color: rgb(var(--bs-primary-rgb));
		transition: transform 200ms ease;
	}
}

@media (prefers-reduced-motion: reduce) {
	.ef-page-progress,
	.ef-page-progress .ef-page-progress-bar {
		transition: none;
	}
}
</style>
